import { render, staticRenderFns } from "./EventParticipantGridComponent.vue?vue&type=template&id=0d56cceb"
import script from "./EventParticipantGridComponent.vue?vue&type=script&lang=js"
export * from "./EventParticipantGridComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports